import * as React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  BreadcrumbsV2,
  ContentsContainer,
  Contents,
  Navigation,
} from "@graffer-inc/console-design-kit";
import { BrowserTemplate } from "../base-template";
import { BannerNotice } from "../../molecules/browser-alert";
import { useAuthContext } from "../../../auth-state";
import { PlanError } from "../../organisms/common/plan-error";
import { Header } from "../../organisms/common/header";
import { emptyFunction } from "../../../utils/function-utils";

export const SmartApplyTemplate: React.FC<{
  children?: React.ReactNode;
  breadcrumbs: Array<{ to: string; title: string }>;
  menuList: React.ReactElement;
  contentsHeader?: React.ReactElement;
}> = ({ breadcrumbs, menuList, contentsHeader, children }) => {
  const authAcc = useAuthContext();
  const title = "スマート申請";

  return (
    <div id="rootWrapper">
      <BannerNotice />
      <BrowserTemplate title={title}>
        <div className="wrapper">
          {authAcc.isProductAvailable("SmartApply") ? (
            <>
              <Navigation>
                <Header title={title} onLogoClick={emptyFunction} />
                {menuList}
                <ContentsContainer>
                  <BreadcrumbsV2.Breadcrumbs
                    list={breadcrumbs}
                    anchor={({ href = "", ...props }) => (
                      <ReactRouterLink {...props} to={href} />
                    )}
                  />
                  {contentsHeader}
                  <Contents>{children}</Contents>
                </ContentsContainer>
              </Navigation>
            </>
          ) : (
            <PlanError title={title} />
          )}
        </div>
      </BrowserTemplate>
    </div>
  );
};
